import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import api from "../../../_metronic/helpers/api";
import { showAlert } from "../../redux/reducers/alertSlice";
import { setTitle } from "../../redux/reducers/mainSlice";
import { stringify } from "qs";

function useUtils() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  dispatch(setTitle("Announcement"))

  const fetchAnnouncements = async(limit=10, offset=0) => {
    const params = {
      limit,
      offset,
    };
    try {
      const response = await api.get(`/announcement?${stringify(params)}`);
      if (response.data.status) {
        return response.data.data
      }
    } catch (error) {
      dispatch(
        showAlert({
          message: error?.response?.data?.message || "Network Error",
          variant: "danger",
        })
      );
    }
  };
 
  const createAnnouncement=async(data)=>{
    try {
      const response = await api.post(`/announcement`, data);
      if (response?.data?.status) {    
        dispatch(showAlert({message: 'Announcement Created', variant: 'success'}))
        navigate('/announcementlist')
      }
    } catch (error) {
      dispatch(showAlert({message: error?.response?.data?.message, variant: 'danger'}))
    }
  }

  const deleteAnnouncement= async (id, limit, offset) => {
    try {
      const response = await api.delete(`/announcement/${id}`);
      if (response?.data?.status) {
        dispatch(
          showAlert({ message: "Successfully deleted", variant: "success", timeout:'1000'})
        );
        return fetchAnnouncements(limit, offset);
      }
    } catch (error) {
      dispatch(
        showAlert({
          message: error?.response?.data?.message,
          variant: "danger",
        })
      );
    }
  };

  const deleteBulkAnnouncements= async (ids, limit, offset) => {
    try {
      const response = await api.post(`/announcement/bulk-delete`,{ids});
      if (response?.data?.status==='success') {
        dispatch(
          showAlert({ message: "Successfully deleted", variant: "success", timeout:'1000'})
        );
        return fetchAnnouncements(limit, offset);
      }
    } catch (error) {
      dispatch(
        showAlert({
          message: error?.response?.data?.message,
          variant: "danger",
        })
      );
    }
  };

  const onEdit = async (id) => {
    try {
      const response = await api.get(
        '/announcement/'+id
      );
      if (response.data.status) {
        return response.data.data;
      }
    } catch (error) {
      dispatch(
        showAlert({
          message: error?.response?.data?.message,
          variant: "danger",
        })
      );
    }
  };

  const fetchAnnouncementT = async() => {
    try {
      const response = await api.get(`/announcement-type`);
      if (response.data.status) {
        return response.data.data.records
      }
    } catch (error) {
      dispatch(
        showAlert({
          message: error?.response?.data?.message,
          variant: "danger",
        })
      );
    }
  };

  const updateAnnouncement = async(id, data) => {
    try{
      const response = await api.patch(`announcement/${id}`, data)
      if (response.data.status) {
        dispatch(showAlert({message: 'Announcement updated', variant: 'success'}))
        navigate('/announcementlist')
      }
    } catch (error) {
      dispatch(showAlert({message: error?.response?.data?.message, variant: 'danger'}))
    }
  }

  return {
    fetchAnnouncements,
    fetchAnnouncementT,
    onEdit,
    createAnnouncement,
    deleteAnnouncement,
    deleteBulkAnnouncements,
    updateAnnouncement
  };
}

export default useUtils;
